import mermaid from 'mermaid';
import { useEffect, useRef, useState } from 'react';

interface ErdDiagramProps {
  diagram: string;
}

let mermaidInitialized = false;

/** Renders a Mermaid `erDiagram` string to SVG. Imperative by nature — mermaid
 * owns SVG generation, React only owns the container it's injected into. */
export function ErdDiagram({ diagram }: ErdDiagramProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!mermaidInitialized) {
      mermaid.initialize({ startOnLoad: false });
      mermaidInitialized = true;
    }

    let cancelled = false;
    setError(null);

    mermaid
      .render('docs-erd-diagram', diagram)
      .then(({ svg }) => {
        if (!cancelled && containerRef.current) {
          containerRef.current.innerHTML = svg;
        }
      })
      .catch((renderError: unknown) => {
        if (!cancelled) {
          setError(
            renderError instanceof Error ? renderError.message : 'Erreur de rendu du diagramme.',
          );
        }
      });

    return () => {
      cancelled = true;
    };
  }, [diagram]);

  return (
    <>
      {error && (
        <p className="text-danger text-small">Impossible d'afficher le diagramme : {error}</p>
      )}
      <div ref={containerRef} className="overflow-x-auto" />
    </>
  );
}
